var map = {
	"./404image.svg": 7049,
	"./Comingsoon.svg": 3485,
	"./Footer.svg": 7507,
	"./GemPrfBanner.svg": 3577,
	"./GemPrfLogo.svg": 2274,
	"./OS.svg": 2652,
	"./ST.svg": 5675,
	"./UF.svg": 5446,
	"./footertagline.svg": 9106,
	"./icon_fb.svg": 2943,
	"./icon_insta.svg": 1704,
	"./icon_linkedin.svg": 4320,
	"./icon_twitter.svg": 5901,
	"./tempBanner.svg": 1527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;